module.exports = __webpack_public_path__ + "assets/microsoft-sharepoint.a2eb5cf8.svg";